import { EthereumStaking } from './api.js'

const { DELEGATE, UNSTAKE, UNSTAKE_PENDING, CLAIM_UNSTAKE } = EthereumStaking.METHODS_IDS

const STAKING_MANAGER_CONTRACTS = new Set([
  EthereumStaking.addresses.ethereum.EVERSTAKE_ADDRESS_CONTRACT_POOL.toLowerCase(),
  EthereumStaking.addresses.ethereumgoerli.EVERSTAKE_ADDRESS_CONTRACT_POOL.toLowerCase(),
  EthereumStaking.addresses.ethereumholesky.EVERSTAKE_ADDRESS_CONTRACT_POOL.toLowerCase(),
])

export const isEthereumStakingTx = ({ coinName }) =>
  ['ethereum', 'ethereumgoerli', 'ethereumholesky'].includes(coinName)
export const isEthereumDelegate = (tx) =>
  isEthereumStakingTx(tx) && STAKING_MANAGER_CONTRACTS.has(tx.to) && tx.data?.methodId === DELEGATE
export const isEthereumUndelegatePending = (tx) =>
  isEthereumStakingTx(tx) && tx.data?.methodId === UNSTAKE_PENDING
export const isEthereumUndelegate = (tx) =>
  (isEthereumStakingTx(tx) && tx.data?.methodId === UNSTAKE) || isEthereumUndelegatePending(tx)
export const isEthereumClaimUndelegate = (tx) =>
  isEthereumStakingTx(tx) && tx.data?.methodId === CLAIM_UNSTAKE
